<template>
  <div class="luggageApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:12px"></div>
    <div class="merchants" v-for="(item,i) in setLuggage" @click="$router.push('lugpro?id='+item.id)">
      <div class="brand">
        <el-image style="width: 80px; height: 80px" :src="baseUrl+item.image" fit="cover"></el-image>
        <span>集中点</span>
      </div>
      <div class="title">
        <h3>{{item.title}}</h3>
        <div class="timer">
          <span>营业时间:{{item.business}}</span>
        </div>
        <div class="star">
          <span>销量：{{item.total}}</span>
        </div>
      </div>
      <div style="clear:both"></div>
      <dl>
        <dt><i class="el-icon-menu"></i> 热销服务</dt>
        <dd v-for="(vo,i) in item.names">
          <div class="proImg">
            <el-image style="width: 50px; height: 45px" :src="baseUrl+vo[3]" fit="cover"></el-image>
          </div>
          <div class="hotPro">
            <p>{{vo[0]}}</p>
            <div class="price">
              <span><i>￥</i>{{vo[2]}}</span>
              <font>￥{{vo[1]}}</font>
            </div>
          </div>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setLuggage:[],
        code:'',
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/Luggage');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.getLuggage();
      }
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      getLuggage:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/luggage/getLuggageStart',
          dataType:'json',
          success:function(data){
            that.setLuggage = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data;
          that.getLuggage();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:80%
  }
  
  .luggageApp{
    max-width:750px;
    background:#F1F2F5;
    margin:0 auto;
  }
  .luggageApp .merchants{
    background:#fff;
    width:96%;
    display:block;
    margin:0 auto;
    margin-bottom:12px;
    padding-bottom:10px;
    border-radius: 6px;
  }
  .luggageApp .merchants:after,.luggageApp .merchants dl dd:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }

  .luggageApp .merchants .brand{
    float:left;
    width:80px;
    height:80px;
    position:relative;
    margin:10px
  }
  .luggageApp .merchants .brand img{
    display:block;
    width:100%;
    border-radius: 10px;
  }
  .luggageApp .merchants .brand span{
    position:absolute;
    top:50%;
    left:0%;
    font-size:14px;
    color:#fff;
    transform: translateY(-50%);
    width:100%;
    text-align:center;
    font-weight:bold;
  }
  .luggageApp .merchants .title{
    float:left;
    width:calc(100% - 100px);
    margin-top:10px
  }
  .luggageApp .merchants .title h3{
    font-size:18px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#000;
  }
  .luggageApp .merchants .title .timer{
    display:block;
    padding:6px 0
  }
  .luggageApp .merchants .title .timer span{
    font-size:14px;
    color:#3C485C;
  }
  .luggageApp .merchants .title .star span{
    color:#3C485C;
    font-weight:500;
    font-size:14px;
  }


  .luggageApp .merchants dl{
    margin: 0 auto;
    width:94%;
    background:#F1F2F5;
    padding-bottom:1px;
    border-radius: 6px;
  }
  .luggageApp .merchants dl dt{
    font-size:15px;
    padding:10px;
    font-weight:bold
  }
  .luggageApp .merchants dl dd{
    margin-bottom:10px;
  }
  .luggageApp .merchants dl dd .proImg{
    width:50px;
    height:45px;
    float:left;
    margin:0 10px 0 10px
  }
  .luggageApp .merchants dl dd .proImg img{
    border-radius: 6px;
  }
  .luggageApp .merchants dl dd .hotPro{
    float:left;
    width:calc(100% - 70px);
  }
  .luggageApp .merchants dl dd p{
    font-size:15px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#000;
    display:block;
    width:100%;
    margin-bottom:6px
  }
  .luggageApp .merchants dl dd .price span{
    color: #FF1E00;
    font-size:14px;
    font-weight:600;
    padding-right:5px
  }
  .luggageApp .merchants dl dd .price i{
    font-weigth:normal;
    font-size:13px;
    font-style: normal;
  }
  .luggageApp .merchants dl dd .price font{
    font-size:13px;
    text-decoration: line-through;
    color:#999;
    padding-left:5px
  }
</style>